import React from 'react'
import './App.scss'
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom'
import OptionContextProvider from "./utils/Context/optionContext"

import Login from './pages/auth/Login'
import Reset from './pages/auth/Reset'
import AdminMaster from './pages/admin/master/Index'
import FourOFour from './pages/fourOfour/Index'

import ScrollToTop from './components/scrollToTop/Index'
import PrivateRoute from './components/privateRoute/Index'

function App() {
  return (
    <div className="App">
      <OptionContextProvider>
        <Router>
          <ScrollToTop>
            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route exact path="/reset" element={<Reset />} />

              <Route path="/dashboard/*" element={
                <PrivateRoute>
                  <AdminMaster />
                </PrivateRoute>
              } />

              <Route path="*" element={<FourOFour />} />
            </Routes>
          </ScrollToTop>
        </Router>
      </OptionContextProvider>
    </div>
  );
}

export default App;